export const createLatestRequestGuard = () => {
  let latestRequestId = 0;

  return {
    invalidate: () => {
      latestRequestId += 1;
    },
    isLatest: (requestId: number) => requestId === latestRequestId,
    start: () => {
      latestRequestId += 1;
      return latestRequestId;
    },
  };
};
